import theme from "@/theme";
import { SVGProps } from "react";

const AddProfilePhotoSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <rect width={22} height={22} x={1} y={1.5} fill={theme.palette.custom.mainBlue} rx={11} />
    <rect width={22} height={22} x={1} y={1.5} stroke="#fff" strokeWidth={2} rx={11} />
    <path
      fill="#fff"
      d="M12.666 7.834a.667.667 0 0 0-1.333 0v4h-4a.667.667 0 1 0 0 1.333h4v4a.667.667 0 1 0 1.333 0v-4h4a.667.667 0 0 0 0-1.333h-4v-4Z"
    />
  </svg>
);
export default AddProfilePhotoSvg;
